<template>
  <div>
    <BRow class="my-2">
      <BCol
        v-for="(item, idx) in listCard"
        :key="idx"
        lg="4"
        class="mb-2"
      >
        <BCard
          class="border rounded-lg m-0 h-[10rem]"
        >
          <div class="text-black flex items-center">
            <div
              :class="item.classIcon"
              class="border rounded-pill p-[5px] mr-[5px]"
            >
              <img
                :src="item.icon"
                class="w-8"
              >
            </div>
            <strong>{{ item.title }}</strong>
          </div>
          <BSpinner
            v-if="loadingCard"
            small
            variant="primary"
          />
          <div class="d-flex">
            <div
              class="my-1 ml-2 text-black text-[34px] font-medium"
            >
              {{ item.count }}
            </div>
            <div
              v-if="item.issubCount"
              class="my-1 ml-2 text-black font-medium"
            >
              <div class="text-muted mb-[7px]">
                Total :
              </div>
              <div>
                {{ IDR(item.subCount) }}
              </div>
            </div>
          </div>
        </BCard>
      </BCol>
    </BRow>
  </div>
</template>

<script>
import { IDR } from '@/libs/currency'

export default {
  data() {
    return {
      listCard: [
        {
          id: 1, title: 'Direview', count: 0, icon: 'https://storage.googleapis.com/komerce/icon/box-time.svg', issubCount: false, classIcon: 'bg-[#FFF2E2]',
        },
        {
          id: 2, title: 'Disetujui', count: 0, icon: 'https://storage.googleapis.com/komerce/icon/box-tick.svg', issubCount: true, subCount: 0, classIcon: 'bg-[#DCF3EB]',
        },
        {
          id: 3, title: 'Ditolak', count: 0, icon: 'https://storage.googleapis.com/komerce/icon/box-remove.svg', issubCount: false, classIcon: 'bg-[#FFEDED]',
        },
      ],
      loadingCard: false,
      IDR,
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    getListData() {
      this.$http_new.get('/komship/api/v1/claims/info')
        .then(res => {
          const { data } = res.data
          this.listCard.map((item, index) => {
            if (item.id === 1) {
              this.listCard[index].count = data.total_on_review
            }
            if (item.id === 2) {
              this.listCard[index].count = data.total_approved
              this.listCard[index].subCount = data.total_approved_claim_nominal
            }
            if (item.id === 3) {
              this.listCard[index].count = data.total_rejected
            }
            return item
          })
        })
        .catch(response => {
          this.$toast_error({ message: 'Gagal Mendapatkan Data Card' })
        })
    },
  },
}
</script>
